module.exports = __webpack_public_path__ + "static/media/sendmsgbtn.eb1cc3c7.svg";